import React, { useState } from 'react';
import marked from 'marked'; // Markdown parser
import { connect } from 'react-redux';
import moment from 'moment';
import TextareaAutosize from 'react-autosize-textarea/lib';
import get from "lodash/get";

import AutoTextType from './AutoTextType';
import { decodeString } from '../../utils/helper';
import Loader from '../misc/Loader';

import { chatBotMessageFeedback, resetInteractionForm, updateSingleChatBotMessage } from '../../actions/chatbot/common';
import ThumbsUp from '../../assets/images/chatbot/thumbs-up.svg';
import ThumbsDown from '../../assets/images/chatbot/thumbs-down.svg';
import FilledThumbsDown from '../../assets/images/chatbot/filled-thumbs-down.svg';
import FilledThumbsUp from '../../assets/images/chatbot/fileld-like.svg';
import CloseIcon from "../../assets/images/common/modals/close.svg";
import DownLoadIcon from '../../assets/images/chatbot/download-icon.svg';

import CommonPortal from '../modals/common/CommonPortal';
import PostCommonModals from '../modals/common/PostCommonModals';
import { showPhotoModal } from '../../actions/common/modals';
import showToaster from '../misc/Toaster';
import { genericErrorText } from '../../utils/commonVariables';
import ReadMoreLinkified from '../../containers/loggedIn/Feed/common/ReadMoreLinkified';
import { escapeHtml } from '../../utils/chatbotHelper';

const TextMessageWithoutTyping = (props) => {
    const { text } = props;
    return (
        <ReadMoreLinkified
            isOpen
            text={decodeString(text, true)} />
    )
}

const ResponseComponent = (props) => {
    const { id, handleSubmitUnlikeMessage, resetInteractionForm } = props;
    const [interactionMessage, setInteractionMessage] = useState("");
    const handleClose = () => {
        resetInteractionForm();
    }
    const disabled = !interactionMessage;
    return (

        <li key={id} className="unlike-message--container">
            <p className="title">
                Tell us more:
                <img src={CloseIcon} className="cursor-pointer" onClick={handleClose} height={"auto"} width={"12px"} />
            </p>
            <TextareaAutosize className='input'
                placeholder='Optional feel free to add specific details'
                minRows={1}
                maxRows={3}
                value={interactionMessage}
                onChange={(e) => setInteractionMessage(e.target.value.slice(0, 2000))}
                type='text'
            />
            <p className="subtitle">Submitting feedback will include this full conversation to help improve  Ask Pihu.</p>
            <button className={`btn cursor-pointer ${disabled ? "disabled" : ""}`} disabled={disabled} onClick={(e) => handleSubmitUnlikeMessage(e, id, interactionMessage)}>Submit</button>
        </li>
    )
}

const MessageListItem = (props) => {
    const { handleLikeOrUnlike,
        item,
        handleSubmitUnlikeMessage,
        showPhotoModal,
        resetInteractionForm,
        handleVisualizeData,
    } = props;

    const { id, isSelf, created_at, message, liked, unliked,
        showInteractionForm,
        isheaderMessage,
        isTyping,
        fetching,
        visualization_recommended: showMediaAction,

    } = item;

    // Markdown renderer for message content
    const renderer = new marked.Renderer();

    renderer.link = function (href, title, text) {
        return `<a href="${href}" target="_blank" class="link">${href}</a>`
    }
    renderer.image = function (href, title, text) {
        const id = `img-${href.slice(-8)}`;
        const img = document.getElementById(id); // Save the id during rendering
        const togglePhotoModal = () => {
            showPhotoModal({
                photos: href,
                isMultiple: false,
                selectedPhoto: href,
                selectedIndex: 0,
            });
        };
        if (img) {
            img.addEventListener("click", () => {
                togglePhotoModal();
            });
        }
        return `
        <article class="image-container">
            <img
                id="${id}"
                src="${href}"
                alt="${text}"
                class="img cursor-pointer"
                title="${title || ''}"
            />
            <div class="overlay__container">
            <a href="${href}" target="_blank" download="true" class="download-icon"><img src="${DownLoadIcon}"/></a>
            </div>
        </article>
        `;
    };
    renderer.table = function (thead, tbody) {
        return `<table class="table">
        <thead> ${thead}</thead>
         <tbody> ${tbody}</tbody>
        </table>`
    };
    renderer.code = (code, infostring, escaped) => {
        const finalCode = escaped ? code : escapeHtml(code);
        return `<pre><code>${finalCode}</code></pre>`;
    };
    const html = message ? marked(message, { renderer }) : '';

    const time = moment(created_at).format("LT");

    const isDisabled = !!liked || !!unliked;

    // check for show like and unlike button
    const showLikeUnlikeUI = !isSelf && !isTyping && !!message && !isheaderMessage;

    // check for showing interaction ui when we click on unlike
    const showInteractionUI = !isSelf && !!showInteractionForm;
    if (!id) return null;
    return (
        <>
            <li key={id} className={`message__list-item ${isSelf ? 'self' : ''} ${isheaderMessage ? "header-msg" : ""}`}>
                <span className={`message__list-item--content ${fetching ? "fetching" : ""}`}>
                    <>
                        {isSelf ? <TextMessageWithoutTyping text={message} /> : !message ? <Loader isCentered /> :
                            isheaderMessage ? <TextMessageWithoutTyping text={html} /> : <AutoTextType handleTypingStatus={(val) => props.updateItemInfo({ isTyping: val }, props.item)} text={decodeString(html)} />
                        }
                    </>
                    {/* Action button which will show all images / graphs for the prompt */}
                    {showMediaAction && !isTyping &&
                        <button className='message__list-item--content__media-action'
                            onClick={() => {
                                props.updateItemInfo({ visualization_recommended: false }, props.item);
                                handleVisualizeData()
                            }
                            }
                        >
                            <span className='icon' />
                            <span>Show data visually</span>
                        </button>
                    }
                    {/* Feedback UI */}
                    {showLikeUnlikeUI &&
                        <div className='footer-action--conatiner'>
                            <button
                                onClick={(e) => handleLikeOrUnlike(e, "like", id)}
                                disabled={isDisabled}
                                className='img cursor-pointer'>
                                <img src={liked ? FilledThumbsUp : ThumbsUp} height={"auto"} width={"16px"} />
                            </button>
                            <button
                                onClick={(e) => handleLikeOrUnlike(e, "unlike", id)}
                                disabled={isDisabled}
                                className='img cursor-pointer'>
                                <img src={unliked ? FilledThumbsDown : ThumbsDown} height={"auto"} width={"16px"} />
                            </button>
                        </div>}
                </span>
                <p className='message__list-item--time'>{time}</p>
            </li>
            {!!showInteractionUI && <ResponseComponent
                id={id}
                handleSubmitUnlikeMessage={handleSubmitUnlikeMessage}
                resetInteractionForm={resetInteractionForm}
            />}
        </>
    )
};


const ChatBotMessages = ({
    messages,
    updateSingleChatBotMessage,
    token,
    isAnyMesssageTyping,
    showPhotoModal,
    chatBotMessageFeedback,
    resetInteractionForm,
    handleVisualizeData
}) => {
    const updateItemInfo = (val, item) => {
        updateSingleChatBotMessage({
            ...item,
            ...val
        })
    }
    const scrollPanelToBottom = () => {
        setTimeout(() => {
            const messagePanel = document.querySelector('.chatbot__messages');
            if (messagePanel) {
                messagePanel.scrollTo({
                    top: messagePanel.scrollHeight,
                    behavior: 'smooth'
                });
            }
        }, 0);
    }
    const handleLikeOrUnlike = (e, type, id, message) => {
        if (!e) return;
        e.preventDefault();
        const data = {
            feedback: type === "like" ? "positive" : "negative",
            feedback_comment: message ? message : "",
        }
        chatBotMessageFeedback(id, data, type, token).then(res => {
            const isError = get(res, "errors.status", false);
            if (!!res && !isError) {
                if (type === "unlike") {
                    scrollPanelToBottom();
                }
            } else {
                const errorText = get(res, "errors.display_message", genericErrorText.general);
                alert(errorText);
                return false;
            }
        });
    }
    const handleSubmitUnlikeMessage = (e, id, message) => {
        if (!e) return;
        e.preventDefault();
        const data = {
            feedback: "negative",
            feedback_comment: message ? message : "",
        }
        chatBotMessageFeedback(id, data, "submit", token).then((res) => {
            const isError = get(res, "errors.status", false);
            if (!!res && !isError) {
                showToaster({
                    text: get(res, "data", "Thank you for feedback")
                })
            } else {
                const errorText = get(res, "errors.display_message", genericErrorText.general);
                alert(errorText);
                return false;
            }
        });
    };

    return (
        <>
            <div className='chatbot__messages'>
                {!!messages.length && <ul className='list-unstyled message__list'>
                    {messages.map((each) => {
                        return <MessageListItem item={each}
                            updateItemInfo={updateItemInfo}
                            handleLikeOrUnlike={handleLikeOrUnlike}
                            isAnyMesssageTyping={isAnyMesssageTyping}
                            handleSubmitUnlikeMessage={handleSubmitUnlikeMessage}
                            showPhotoModal={showPhotoModal}
                            resetInteractionForm={resetInteractionForm}
                            handleVisualizeData={handleVisualizeData}
                        />
                    })}
                </ul>}
            </div>
            <CommonPortal>
                <PostCommonModals />
            </CommonPortal>
        </>
    )
}


function mapStateToProps(state) {
    return {
        view: state.chatBotReducer.view,
        token: state.login.token,
    }
}

const mapDispatchToProps = {
    updateSingleChatBotMessage,
    chatBotMessageFeedback,
    showPhotoModal,
    resetInteractionForm,
}
export default connect(mapStateToProps, mapDispatchToProps)(ChatBotMessages);